import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="url(#paint0_linear_1_1326)"
        d="M7.5 1C11.09 1 14 3.738 14 7.115c0 2.323-1.377 4.344-3.405 5.379a711.64 711.64 0 01-3.826 1.885.88.88 0 01-1.267-.79c0-.389-.257-.726-.616-.874C2.597 11.77 1 9.618 1 7.115 1 3.738 3.91 1 7.5 1zM4.149 7.505A.69.69 0 003.937 8a.69.69 0 00.212.495A4.817 4.817 0 007.5 9.84a4.817 4.817 0 003.351-1.345.688.688 0 00-.009-.981.735.735 0 00-1.012-.009c-.306.297-.67.532-1.07.692a3.386 3.386 0 01-2.52 0c-.4-.16-.764-.395-1.07-.692a.734.734 0 00-.51-.205.734.734 0 00-.511.205z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_1_1326"
          x1="1.249"
          x2="15.274"
          y1="1.462"
          y2="3.329"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#13CB75"></stop>
          <stop offset="1" stopColor="#13CB9F"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default Icon;
